































import { countries } from '@/constants';
import { concatValues } from '@/utils';

export default {
  props: [
    'contact',
    'date',
    'dateFormat',
    'notes',
    'title',
  ],
  computed: {
    address(): string|void {
      if (this.addressDetails && this.country)  {
        return [
          this.addressDetails,
          this.country,
        ].join(', ');
      } else if (this.addressDetails) {
        return this.addressDetails;
      } else if (this.country) {
        return this.country;
      }
    },
    addressDetails(): string {
      return concatValues(
        this.contact, [
          'contactName',
          'companyName',
          'address',
        ],
        ', ',
      );
    },
    country(): string {
      return (countries as any)[this.contact.country];
    },
    markedNotes(): string {
     return this
      .$markdown(this.notes || '')
      .replace(/\n/g, '<br />');
    },
  },
} as IView;
